export const iconFontAwesomeCampingMapLocationDot = (
	<i className="fa-solid fa-map-location-dot"></i>
);
